import React, {Component} from "react"
import ZancaSortDeviceOverviewContextProvider from "./context/ZancaSortDeviceOverviewContext";
import TabLayout, {NavigationRoutes} from "../../util/TabLayout";
import Column from "@amzn/meridian/column";
import {ZANCA_SORT} from "../../util/RouteConstants";

/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */

class ZancaSortDevicePage extends Component{
    render() {
        return (
            <Column>
                <ZancaSortDeviceOverviewContextProvider>
                    <TabLayout routes={ZANCA_SORT} location={this.props.location} history={this.props.history}/>
                    <NavigationRoutes routes={ZANCA_SORT}/>
                </ZancaSortDeviceOverviewContextProvider>
            </Column>
        )
    }
}

export default ZancaSortDevicePage;


// WEBPACK FOOTER //
// ./src/components/devicemanagement/zancasort/ZancaSortDevicePage.js